import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import "./Finance.css";
import PhoneIcon from "@mui/icons-material/Phone";
import laptoppiechart from "../../assets/images/services/finance/laptoppiechart.png";
import transparency from "../../assets/images/services/finance/transparency.png";
import decentralisation from "../../assets/images/services/finance/decentralisation.png";
import auditing from "../../assets/images/services/finance/auditing.png";
import smartcontract from "../../assets/images/services/finance/smartcontract.png";
import financesecurity from "../../assets/images/services/finance/financesecurity.png";
import tokenisation from "../../assets/images/services/finance/tokenisation.png";

const Finance = () => {
  return (
    <Fragment>
      <section className="finance-style">
        <div className="finance-banner-content">
          <div className="container">
            <div
              className="subtitle-gradient"
              data-aos="fade-down"
              data-aos-delay="200"
              data-aos-duration="1200"
            >
              Finance
            </div>
            <h1
              data-aos="fade-down"
              data-aos-delay="400"
              data-aos-duration="1200"
            >
              Blockchain in Finance
            </h1>
            <p
              data-aos="fade-down"
              data-aos-delay="600"
              data-aos-duration="1200"
            >
              The financial industry is recognizing the transformative impact of
              blockchain technology to generate new revenue, deliver process
              efficiency, improve end-user experience and reduce risk in
              business operations.
            </p>
            <div
              className="consultation-btn"
              data-aos="fade-down"
              data-aos-delay="800"
              data-aos-duration="1200"
            >
              <NavLink to="/contact" target="-black">
                <span>
                  Request A Consultation <PhoneIcon />
                </span>
              </NavLink>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="finance-content">
            <div className="row">
              <div className="col-lg-5 d-flex align-items-center justify-content-center">
                <div className="finance-left-image">
                  <img
                    src={laptoppiechart}
                    alt="img-not-found"
                    data-aos="zoom-in-up"
                    data-aos-delay="200"
                    data-aos-duration="1200"
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <h4
                  className="mb-4"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1200"
                >
                  Blockchain for Finance
                </h4>
                <p
                  className="mb-5"
                  data-aos="fade-up-left"
                  data-aos-delay="400"
                  data-aos-duration="1200"
                >
                  The implementation of blockchain technology in finance can
                  have a major impact on improving customer experience and
                  compliance throughout the industry. The increased transparency
                  provided by blockchain can give customers greater insight into
                  their transactions, allowing them to better track their money
                  and make more informed decisions about their investments.
                  Clients thus feel more secure in their financial decisions, as
                  they can trust that the information provided is correct,
                  up-to-date and trustworthy. Blockchain technology also ensures
                  that clients' assets are better protected against cyber
                  attacks or fraudulent activities. It also protects the data
                  from unauthorised access or manipulation and makes it
                  impossible to infiltrate the system or steal information.
                  Automation is another factor - smart contracts enable the
                  automation of tedious processes, such as compliance checks,
                  which means less paperwork to deal with. Also, the
                  aforementioned tokenisation of assets helps the clientele
                  better understand the true value of their investments, which
                  further strengthens trust in the financial system. Finally,
                  customers may benefit from lower transaction fees due to the
                  reduced need for third-party intermediaries.
                </p>
              </div>
            </div>
          </div>

          <div className="finance-service">
            <div className="text-center">
              <h1
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-duration="1200"
              >
                Benefits of blockchain in Finance
              </h1>
            </div>
            <div className="container">
              <div className="row">
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="200"
                  data-aos-duration="1200"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>Increased transparency</h6>
                      <p>
                        Blockchain's immutable and transparent nature can
                        provide a clear view of all transactions and balances,
                        making it difficult for institutions to hide illicit
                        activities or obscure financial positions.
                      </p>
                    </div>
                    <div className="finance-service-icon1 d-flex align-items-center justify-content-center">
                      <img src={transparency} alt="img-not-found" />
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="400"
                  data-aos-duration="1200"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>Decentralisation</h6>
                      <p>
                        Since there exists no central authority controlling the
                        blockchain system, the likelihood of a single point of
                        failure is reduced. This can help mitigate the impact of
                        an individual institution's collapse on the overall
                        financial system.
                      </p>
                    </div>
                    <div className="finance-service-icon2 d-flex align-items-center justify-content-center">
                      <img src={decentralisation} alt="img-not-found" />
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="600"
                  data-aos-duration="1200"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>Real-time auditing</h6>
                      <p>
                        Blockchain allows for real-time auditing, which can help
                        regulators and other stakeholders to identify potential
                        issues early on and take appropriate corrective actions.
                      </p>
                    </div>
                    <div className="finance-service-icon3 d-flex align-items-center justify-content-center">
                      <img src={auditing} alt="img-not-found" />
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="800"
                  data-aos-duration="1200"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>Smart contracts</h6>
                      <p>
                        Using blockchain-based smart contracts can automate
                        various financial processes and agreements, reducing the
                        likelihood of human error and fraud.
                      </p>
                    </div>
                    <div className="finance-service-icon4 d-flex align-items-center justify-content-center">
                      <img src={smartcontract} alt="img-not-found" />
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="1000"
                  data-aos-duration="1200"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>Enhanced security</h6>
                      <p>
                        Blockchain's cryptographic features make it less
                        susceptible to cyber-attacks and fraud, ensuring secure
                        and tamper-proof records.
                      </p>
                    </div>
                    <div className="finance-service-icon5 d-flex align-items-center justify-content-center">
                      <img src={financesecurity} alt="img-not-found" />
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="1000"
                  data-aos-duration="1200"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>Tokenisation of assets</h6>
                      <p>
                        Tokenisation refers to the process of converting assets
                        into digital tokens within the blockchain. Tokenisation
                        converts physical or intangible assets into a digital
                        format that is easily tradable, shareable and
                        accessible.
                      </p>
                    </div>
                    <div className="finance-service-icon6 d-flex align-items-center justify-content-center">
                      <img src={tokenisation} alt="img-not-found" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Finance;
